<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <!-- SIDEBAR -->
    <fuse-sidebar class="sidebar" name="device-group-main-sidebar" position="left" lockedOpen="gt-md">
        <vat-rate-main-sidebar></vat-rate-main-sidebar>
    </fuse-sidebar>
    <!-- / SIDEBAR -->

    <!-- CENTER -->
    <div class="center">

        <div class="content-card">
            <!-- CONTENT -->
            <div id="ngx-datatable" class="page-layout simple fullwidth docs">
                <div class="content p-24">
                    <ngx-datatable
                            class="material"
                            [rows]="rows"
                            [loadingIndicator]="loadingIndicator"
                            [columnMode]="'force'"
                            [headerHeight]="48"
                            [footerHeight]="56"
                            [rowHeight]="'auto'"
                            [scrollbarH]="true"
                            [reorderable]="reorderable"
                            [selectionType]="'checkbox'"
                            (select)="'onCheckboxChangeFn($event)'"
                            [selected]="selected"
                            [limit]="10">

                        <ngx-datatable-column [width]="48"
                                              [canAutoResize]="false"
                                              [sortable]="false">
                            <ng-template ngx-datatable-header-template let-value="value" let-allRowsSelected="allRowsSelected"
                                         let-selectFn="selectFn">
<!--                                <mat-checkbox [checked]="allRowsSelected" (change)="selectFn(!allRowsSelected)"></mat-checkbox>-->
                            </ng-template>

                            <ng-template ngx-datatable-cell-template let-value="value" let-isSelected="isSelected"
                                         let-onCheckboxChangeFn="onCheckboxChangeFn">
<!--                                <mat-checkbox [checked]="isSelected"></mat-checkbox>-->
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="{{'Country'|translate}}" prop="country.name"></ngx-datatable-column>

                        <ngx-datatable-column name="{{'Vat name'|translate}}" prop="vatName"></ngx-datatable-column>
                        <ngx-datatable-column name="{{'Vat value'|translate}}" prop="vatValue"></ngx-datatable-column>

                        <ngx-datatable-column name="{{'Actions'|translate}}" sortable="false" prop="id">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>

                                <a *appIsGranted="['VAT rates', 'UPDATE']" routerLink="/settings/vat-rates/edit/{{row.id}}">{{'Edit'|translate}}</a>

                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                </div>
            </div>
        </div>
    </div>
</div>